import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  APPOINTMENT_ITEM_ADDED,
  APPOINTMENT_RECEIVED,
  PATIENT_LIST_RECEIVED,
} from "../constants/types/appointmentType";
import axios from "../utils/axios";

import { appLoading } from "./alertAction";

export const getAppoitmentList =
  (start_date, end_date, practitioner_id, callback) => (dispatch) => {
    axios
      .get(
        `appointment?action=getAppointmentList&start_date=${start_date
          .toISOString()
          .slice(0, 19)
          .replace("T", " ")}&end_date=${end_date
          .toISOString()
          .slice(0, 19)
          .replace("T", " ")}${
          practitioner_id && "&practitioner_id="
        }${practitioner_id}`
      )
      .then(
        (resp) => {
          if (resp.data?.result === "success") {
            dispatch({
              type: APPOINTMENT_RECEIVED,
              payload: resp.data.appointmentList,
            });
            callback && callback();
          } else {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
            callback && callback();
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const appointmentPostAction = (data, callback) => (dispatch) => {
  axios.post("appointment", data).then(
    (resp) => {
      if (resp.data?.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getPatientList = (id, callback) => (dispatch) => {
  axios.get(`appointment?action=getPatientList&id=${id}`).then(
    (resp) => {
      if (resp?.data) {
        dispatch({
          type: PATIENT_LIST_RECEIVED,
          payload: resp.data.patientList,
        });
        callback && callback();
      } else {
        dispatch({
          type: PATIENT_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};
